import React from 'react';
import { Spin, Alert, Button, Modal } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import useAppInitialization from 'utils/hooks/useAppInitialization';
import styled from '@emotion/styled';
import { ConsentForm } from './ConsentForm';

const InitializerWrapper = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #ffffff;
	z-index: 9999;
`;

const InitializerContent = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 2rem;
	max-width: 400px;
	text-align: center;
`;

const AppLogo = styled.img`
	max-width: 200px;
	margin-bottom: 2rem;
`;

const LoadingText = styled.p`
	margin-top: 1rem;
	color: #666;
	font-size: 14px;
`;

/**
 * Componente que maneja la inicialización de la aplicación
 * Verifica la autenticación y datos del usuario antes de mostrar la app principal
 */
const AppInitializer = ({ children }) => {
	const {
		isInitialized,
		isLoading,
		error,
		forceRefresh,
		hasValidSession,
		needsConsent,
	} = useAppInitialization();

	// Mostrar spinner durante la inicialización
	if (!isInitialized || isLoading) {
		return (
			<InitializerWrapper>
				<InitializerContent>
					<AppLogo src='/img/logo-ortuzar.png' alt='Logo' />
					<Spin size='large' />
					<LoadingText>
						{isLoading
							? 'Verificando sesión...'
							: 'Inicializando aplicación...'}
					</LoadingText>
				</InitializerContent>
			</InitializerWrapper>
		);
	}

	// Mostrar error con opción de reintentar
	if (error && !hasValidSession) {
		return (
			<InitializerWrapper>
				<InitializerContent>
					<AppLogo src='/img/logo-ortuzar.png' alt='Logo' />
					<Alert
						message='Error de Inicialización'
						description={error}
						type='error'
						showIcon
						style={{ marginBottom: '1rem' }}
					/>
					<Button
						type='primary'
						icon={<ReloadOutlined />}
						onClick={forceRefresh}
						loading={isLoading}
					>
						Reintentar
					</Button>
				</InitializerContent>
			</InitializerWrapper>
		);
	}

	return (
		<>
			{children}
			<Modal
				width='90%'
				height='90%'
				open={needsConsent}
				onCancel={() => {}}
				footer={null}
				centered
			>
				<ConsentForm />
			</Modal>
		</>
	);
};

export default AppInitializer;
